export default "__VITE_ASSET__B882KfYK__"